(() => {
  if (customElements.get('keepsake-support')) return;
  const pendingKey = 'doouyou:support:pending';
  const entry = 'https://cdn.shopify.com/storefront/web-components/agent-iframe.js';
  let warmed = false;
  function warmChat() {
    const connection = navigator.connection;
    if (warmed || document.hidden || connection?.saveData || /^(slow-)?2g$/.test(connection?.effectiveType || '')) return;
    if (![...document.querySelectorAll('link[href]')].some(link => link.href === entry && /modulepreload|prefetch/.test(link.rel))) {
      const link = document.createElement('link');
      link.rel = 'modulepreload';
      link.href = entry;
      link.crossOrigin = 'anonymous';
      document.head.append(link);
    }
    warmed = true;
  }
  function pending(value) {
    try { if (value) sessionStorage.setItem(pendingKey, String(Date.now())); else sessionStorage.removeItem(pendingKey); } catch (_) {}
  }
  function wasPending() {
    try { const time = Number(sessionStorage.getItem(pendingKey)); return time > 0 && Date.now() - time < 30 * 60000; } catch (_) { return false; }
  }
  customElements.define('keepsake-support', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.dialog = this.querySelector('dialog');
      this.launcher = this.querySelector('[data-support-launch]');
      this.form = this.querySelector('form');
      if (!this.dialog || !this.launcher || typeof this.dialog.showModal !== 'function') return;
      this.abort = new AbortController();
      const { signal } = this.abort;
      document.body.classList.add('ks-support-ready');
      for (const event of ['pointerenter', 'focusin', 'pointerdown', 'touchstart']) this.launcher.addEventListener(event, warmChat, { once: true, passive: true, signal });
      this.launcher.addEventListener('click', event => { event.preventDefault(); this.open(); }, { signal });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-support-close]')) this.close();
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
        }
      }, { signal });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, { signal });
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('ks-support-open');
        this.launcher.setAttribute('aria-expanded', 'false');
        this.launcher.focus({ preventScroll: true });
      }, { signal });
      this.querySelector('[data-support-chat]')?.addEventListener('click', event => this.openChat(event.currentTarget), { signal });
      document.addEventListener('shopify-chat:close', () => this.launcher.focus({ preventScroll: true }), { signal });
      this.form?.addEventListener('submit', event => {
        if (!this.form.reportValidity() || this.form.dataset.submitting === 'true') { event.preventDefault(); return; }
        this.form.dataset.submitting = 'true';
        pending(true);
        const button = this.form.querySelector('[type="submit"]');
        if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      }, { signal });
      window.addEventListener('pageshow', () => {
        if (!this.form) return;
        delete this.form.dataset.submitting;
        const button = this.form.querySelector('[type="submit"]');
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      }, { signal });
      const url = new URL(location.href);
      const response = url.searchParams.get('doouyou_support') === '1' || url.hash === `#${this.dataset.formId}` || wasPending();
      const success = this.querySelector('[data-support-success]');
      if (response && (success || this.querySelector('[data-support-error]'))) {
        pending(false);
        url.searchParams.delete('doouyou_support');
        if (success) url.searchParams.delete('contact_posted');
        if (url.hash === `#${this.dataset.formId}`) url.hash = '';
        history.replaceState(history.state, '', url.pathname + url.search + url.hash);
        this.open();
      }
    }
    open() {
      if (this.dialog.open || document.querySelector('dialog:modal')) return;
      this.dialog.showModal();
      this.launcher.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ks-support-open');
      warmChat();
    }
    close() { if (this.dialog.open) this.dialog.close(); }
    async openChat(button) {
      const status = this.querySelector('[data-support-status]');
      status.hidden = false;
      status.textContent = button.dataset.loading;
      button.disabled = true;
      warmChat();
      let timeout;
      try {
        await Promise.race([customElements.whenDefined('shopify-chat'), new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('Chat loading')), 3000); })]);
        if (!this.isConnected || !this.dialog.open) return;
        const chat = document.querySelector('shopify-chat');
        if (!chat) throw new Error('Chat unavailable');
        this.close();
        chat.setAttribute('open', '');
        status.hidden = true;
      } catch (_) {
        status.textContent = button.dataset.unavailable;
      } finally {
        clearTimeout(timeout);
        button.disabled = false;
      }
    }
    disconnectedCallback() {
      this.close();
      this.abort?.abort();
      this.abort = null;
      document.body.classList.remove('ks-support-open', 'ks-support-ready');
    }
  });
})();
